import { faqs } from '@/mocks/faq';
import type { FaqItem } from '@/types/content';
import SectionHeading from '@/components/feature/SectionHeading';
import FaqAccordion from '@/components/feature/FaqAccordion';
import Reveal from '@/components/feature/Reveal';

const items = faqs as FaqItem[];

export default function FaqSection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-[0.85fr_1.15fr] gap-10 lg:gap-16">
        <div>
          <SectionHeading
            eyebrow="FAQ"
            title="围观群众常问的几个问题"
            description="关于内容来源、更新节奏和我们做这件事的边界，这里一次说清楚。"
          />
          <div className="mt-6 flex items-center gap-3 text-sm text-foreground-600">
            <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
              <i className="ri-question-line"></i>
            </span>
            还有别的疑问？页面底部可以直接留言给我们。
          </div>
        </div>
        <Reveal>
          <FaqAccordion items={items} />
        </Reveal>
      </div>
    </section>
  );
}